import _ from "lodash";
import React, { useState, useRef, useCallback } from "react";
import { connect } from "react-redux";
import { Link, useParams, useRouteMatch } from "react-router-dom";
import { LocalesValues, PageTitle } from "components/standart";
import { Uploader, AudioPreview, ImagePreview, Text2Mp3Button } from "components/standart";

import IntlMessages from "util/intlMessages";
import { setOnChange } from "components/special";
import { Alert } from "reactstrap";

import { adminAPI } from "redux/api";
import { SwitchValue } from "components/special/forms";

import { apiUrls } from "../init";

const { api } = adminAPI.actions;

const ContentForm = (props) => {
  const { url } = useRouteMatch();
  const { breadCrumbs, content, setContent } = props;
  const params = useParams();
  const [dataSaved, setDataSaved] = useState(false);

  const changeContent = setOnChange(content, setContent);
  breadCrumbs.push({
    title: <IntlMessages id="Contents.Form" />,
    url,
  });

  const [coverImageGenerating, setCoverImageGenerating] = useState(false);
  const createCoverHandler = useCallback(() => {
    const params = { categoryId: content._id };
    props.createCover(
      { params },
      {
        onSuccess(data) {
          // установим файл из ссылки
          setContent({ ...content, templateFileId: data._id });
          setCoverImageGenerating(false);
        },
        onFailure() {
          setCoverImageGenerating(false);
        },
        onRequest() {
          setCoverImageGenerating(true);
        },
      },
    );
  }, [content]);

  const [metaImageGenerating, setMetaImageGenerating] = useState(false);
  const createMetaCoverHandler = useCallback(() => {
    const params = { categoryId: content._id };
    props.createMetaCover(
      { params },
      {
        onSuccess(data) {
          // установим файл из ссылки
          setContent({ ...content, metaTemplateFileId: data._id });
          setMetaImageGenerating(false);
        },
        onFailure() {
          setMetaImageGenerating(false);
        },
        onRequest() {
          setMetaImageGenerating(true);
        },
      },
    );
  }, [content]);

  const [storyImageGenerating, setStoryImageGenerating] = useState(false);
  const createStoryCoverHandler = useCallback(() => {
    const params = { categoryId: content._id };

    props.createStoryCover(
      { params },
      {
        onSuccess(data) {
          // установим файл из ссылки
          setContent({ ...content, templateStoryFileId: data._id });
          setStoryImageGenerating(false);
        },
        onFailure() {
          setStoryImageGenerating(false);
        },
        onRequest() {
          setStoryImageGenerating(true);
        },
      },
    );
  }, [content]);

  const successAlertRef = useRef(null);

  const saveHandler = () => {
    const onSuccess = (body) => {
      setContent(body);
      setDataSaved(true);
      successAlertRef.current.scrollIntoView();
    };

    const onRequest = () => {
      setDataSaved(false);
    };

    const onFailure = () => {
      setDataSaved(false);
    };

    props.saveContent({ params, body: content }, { onSuccess, onFailure, onRequest });
  };

  return (
    <div>
      <PageTitle {...breadCrumbs} />

      <div className="row">
        <div className="col-12">
          <div className="roe-card-style">
            <div className="roe-card-body">
              <div ref={successAlertRef}>
                <Alert
                  className="alert-success"
                  isOpen={dataSaved}
                  toggle={() => setDataSaved(false)}
                >
                  <IntlMessages id="saved" />
                </Alert>
              </div>
              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="name" />
                </label>
                <div className="col-8">
                  <input
                    type="text"
                    name="name"
                    value={content.name || ""}
                    onChange={changeContent}
                    className="form-control react-form-input"
                    autoComplete="off"
                    required
                  />
                </div>
              </div>

              {/* 
              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="description" />
                </label>
                <div className="col-8">
                  <textarea
                    type="text"
                    rows={4}
                    name="description"
                    value={content.description || ""}
                    onChange={changeContent}
                    className="form-control react-form-input"
                    autoComplete="off"
                    required
                  />
                </div>
              </div>
               */}

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="Categories.tag" />
                </label>
                <div className="col-8">
                  <input
                    type="text"
                    name="tag"
                    value={content.tag || ""}
                    onChange={changeContent}
                    className="form-control react-form-input"
                    autoComplete="off"
                    required
                  />
                </div>
              </div>

              {/* 
              <div className="form-group row">
                <div className="col-4 col-form-label">
                  <IntlMessages id="Categories.imageFileId" />
                  <span className="pull-right">
                    <Uploader
                      className="btn-success btn-sm"
                      successHandler={([file]) => setContent({ ...content, imageFileId: file._id })}
                      imagesOnly="true"
                      multiple={false}
                    />
                  </span>
                </div>
                <div className="col">
                  {content.imageFileId && (
                    <ImagePreview
                      file={{ _id: content.imageFileId }}
                      deleteHandler={() => {
                        setContent({ ...content, imageFileId: null });
                      }}
                    />
                  )}
                </div>
              </div>
               */}

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="Categories.soundText" />
                </label>
                <div className="col">
                  <input
                    type="text"
                    name="soundText"
                    value={content.soundText || ""}
                    onChange={changeContent}
                    className="form-control react-form-input"
                    autoComplete="off"
                  />
                </div>

                <div className="col-1">
                  <Text2Mp3Button
                    value={content?.soundText}
                    onSuccess={(file) => setContent({ ...content, soundFileId: file._id })}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="Categories.soundFileId" />
                  <Uploader
                    className="btn-success btn-sm pull-right"
                    successHandler={([file]) => setContent({ ...content, soundFileId: file._id })}
                    accept="*.mp3"
                    multiple={false}
                  />
                </label>
                <div className="col">
                  {content.soundFileId && (
                    <AudioPreview
                      file={{ _id: content.soundFileId }}
                      deleteHandler={() => {
                        setContent({ ...content, soundFileId: null });
                      }}
                    />
                  )}
                </div>
              </div>

              {/* 
              <div className="form-group row">
                <div className="col-4 col-form-label">
                  <IntlMessages id="Categories.metaTemplateFileId" />
                  <span className="pull-right">
                    <button
                      className="btn btn-sm btn-warning mr-2"
                      onClick={createMetaCoverHandler}
                      disabled={metaImageGenerating}
                    >
                      <i className={`fa fa-sync-alt ${metaImageGenerating ? "fa-spin" : ""}`} />
                    </button>
                    <Uploader
                      className="btn-success btn-sm"
                      successHandler={([file]) =>
                        setContent({ ...content, metaTemplateFileId: file._id })
                      }
                      imagesOnly="true"
                      multiple={false}
                    />
                  </span>
                </div>
                <div className="col">
                  {content.metaTemplateFileId && (
                    <ImagePreview
                      file={{ _id: content.metaTemplateFileId }}
                      deleteHandler={() => {
                        setContent({ ...content, metaTemplateFileId: null });
                      }}
                    />
                  )}
                </div>
              </div>
               */}

              <div className="form-group row">
                <div className="col-4 col-form-label">
                  <IntlMessages id="Categories.templateFileId" />
                  <span className="pull-right">
                    <button
                      className="btn btn-sm btn-warning mr-2"
                      onClick={createCoverHandler}
                      disabled={coverImageGenerating}
                    >
                      <i className={`fa fa-sync-alt ${coverImageGenerating ? "fa-spin" : ""}`} />
                    </button>
                    <Uploader
                      className="btn-success btn-sm"
                      successHandler={([file]) =>
                        setContent({ ...content, templateFileId: file._id })
                      }
                      imagesOnly="true"
                      multiple={false}
                    />
                  </span>
                </div>
                <div className="col">
                  {content.templateFileId && (
                    <ImagePreview
                      file={{ _id: content.templateFileId }}
                      deleteHandler={() => {
                        setContent({ ...content, templateFileId: null });
                      }}
                    />
                  )}
                </div>
              </div>

              {/*  временно скрыто */}
              {true ? (
                <div className="form-group row">
                  <div className="col-4 col-form-label">
                    <IntlMessages id="Categories.templateStoryFileId" />
                    <span className="pull-right">
                      <button
                        className="btn btn-sm btn-warning mr-2"
                        onClick={createStoryCoverHandler}
                        disabled={storyImageGenerating}
                      >
                        <i className={`fa fa-sync-alt ${storyImageGenerating ? "fa-spin" : ""}`} />
                      </button>

                      <Uploader
                        className="btn-success btn-sm "
                        successHandler={([file]) =>
                          setContent({ ...content, templateStoryFileId: file._id })
                        }
                        imagesOnly="true"
                        multiple={false}
                      />
                    </span>{" "}
                  </div>
                  <div className="col">
                    {content.templateStoryFileId && (
                      <ImagePreview
                        file={{ _id: content.templateStoryFileId }}
                        deleteHandler={() => {
                          setContent({ ...content, templateStoryFileId: null });
                        }}
                      />
                    )}
                  </div>
                </div>
              ) : null}

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="localesName" />
                  <LocalesValues.AddButton
                    className="btn-sm float-right"
                    values={content.localesName}
                    changeValues={(localesName) => setContent({ ...content, localesName })}
                  />
                </label>
                <div className="col-8">
                  <LocalesValues
                    values={content.localesName}
                    changeValues={(localesName) => setContent({ ...content, localesName })}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="Categories.isRegion" />
                </label>
                <div className="col-8 my-auto">
                  <SwitchValue name="isRegion" value={content.isRegion} onChange={changeContent} />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="tables.enabled" />
                </label>
                <div className="col-8 my-auto">
                  <SwitchValue value={content.enabled} onChange={changeContent} />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-4 col-auto">
                  <button className="form-control c-primary" type="button" onClick={saveHandler}>
                    <IntlMessages id="save" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const FormButton = (props) => {
  const { contentForm, content } = props;
  return (
    <Link to={contentForm(content)} className="btn btn-secondary btn-sm">
      <i className="fa fa-edit" />
    </Link>
  );
};

export default connect(null, {
  saveContent: api.patch(apiUrls.specials_categoriesInfo),
  createMetaCover: api.get(apiUrls.specials_categoriesGenerateCover),
  createCover: api.get(apiUrls.specials_categoriesGenerateCover),
  createStoryCover: api.get(apiUrls.specials_categoriesGenerateStoryCover),
})(ContentForm);
